<div class="custom-modal-scan">
    <div class="modal-header">
        <div class="head-title">
            <i class="mdi mdi-spin mdi-loading mdi-36px"></i>
            <h4>{{ 'IDMS.BARCODE_SCAN.HYDRATIGHT_BARCODE_SCANNING' | transloco }}</h4>
        </div>
        <a class="close-icon" href="javascript:void()" (click)="closeClick()" ngbAutofocus><i class="flaticon2-cross"></i></a>
    </div>
    <div class="modal-body output-lable new-user" (document:click)="handleClick($event)">
        <div class="row" style="padding-top: 20px">
            <div class="col-md-3">
                <div class="row">
                    <div class="col-md-4">
                        <input
                            style="
                                width: 1px;
                                margin-left: 32px;
                                margin-top: 0px;
                                border-radius: 0 !important;
                                background-color: black;
                                border: 1px solid black;
                                border-radius: 0px;
                            "
                            id="scanner-input"
                            type="text"
                            [value]="scannedValue"
                            #scannerInput
                            (keyup.enter)="onScanComplete($event)"
                            (input)="onScannerInput($event)"
                            (focus)="onScannerFocus()"
                            autocomplete="off"
                            autofocus
                        />
                    </div>
                    <div class="col-md-8">
                        <i class="fas fa-barcode fa-2xs" style="font-size: 27px; color: black; margin-top: 12px"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <p>{{ 'IDMS.BARCODE_SCAN.IN_ORDER_TO_SUCCESSFULLY_SCAN_A_HYDRATIGHT_BARCODE_PLEASE_ENSURE_THAT_THIS_POP_UP_IS_OPENED' | transloco }}</p>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn secondary-ebtn" (click)="closeClick()">{{ 'PLANT_MANAGER.Cancel' | transloco }}</button>
        </div>
    </div>
</div>
